// Capability descriptor for plain-browser hosts.
//
// This was a four-surface bridge (db / print / files / events) because Electron
// needed one. Every one of those surfaces had exactly one implementer, and it
// has been deleted, so what remains is the three flags the app actually
// branches on.
const browserHost = {
    caps: {
        isPosDevice: false,
        usesHashRouter: false,
        wantsServiceWorker: true,
    },
};

export default browserHost;
